// A React hook that should be overriden in case the website needs to
// extend the default `siteData`.
const useAdditionalSiteData = () => {};

export default useAdditionalSiteData;
